export default __webpack_public_path__ + "static/media/clash-of-clans.14a44eba.webp";